import { createMachine } from 'xstate'
export const KioskAntrianMachine =
/** @xstate-layout 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 */

/** @xstate-layout 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 */
createMachine({
  /** @xstate-layout N4IgpgJg5mDOIC5QGkCWB7WBrAggOwBcAnVAQzwGIAHAV1gAsEBjdPAM1SgG0AGAXUSgqmVAQx5BIAB6IArAE4AHAEYAdItk8AbACYALDx6L58nQBoQAT0TKdAXzsW0mXIRLlVASQByngCqeOAAyAPoAwgDy3gBingDiAKoASjgBUaoACjhxAKIhABIRALI5Xr5+FEwANqhMWAhgAG5gRJYA7vQtYLwCSCDCsKLikjIIslrKPKoA7PJaegDMOtOaOhoW1ggLulMLRooL8jzKsgZaDk4Y2PjEZHhl-oGhkTHxyame6Vm5BcWlPv4KLAmOQEGI6mACD1JAMhqwRnJ5lNZvMliseGtZBtEAYFgtVMoFtNFtNFPoeNMdLILiBnNc3HcHgFguEorFEik0t5Mtk8oUSqoSt4EiFvjkgSC8GDalhIdC+rCxPC+qNTFpFKoeHtjooDlp5MpFNiEHplnoZvI8TplEcdPoaXTXLcPADmc82W9OZ9uWLfgKhSKxUCwFUwEwCAgALZgPA0eVCERKiQqmxaxRaVTW9U8eQGeSk416ZR6WSak4HRSzWayeyOWlXJ3ue6up6s14cj5fXl+0oB0W84Oh8NRmNx5S9BODJMIhCTQ4ZrOKHN5gtWHHk1RzYxaLTTHM6JQOhs3JtM1svdnvLk8n783s5YX93KDsMR6Oxrg6Cf9RPDFMmrV8XGZY900DE9B3Y0lypTNFm2XRdFkA4jxcE9GRbFkL09TsfW7O9BQfQMB2qGUEHIdpOiIbp+BhX9lVAUZlEJHhzVMSl02g9VzDXE1tmmAl9CUAwD13c460dNCXXKc8PQ7a9fXwvsgykWACFIAgwFUUg2A0ogAAoxGjPx0E8CBQwyUgYAASgoCSGSkx5MNkq9vRvPk-gIx8xXjH8pz-BjEDVDUtUMQ09QNI0eNNZZM0tEs1mzaZphQ+lnWbaSnPbFyu1vDyADVgk8AARHCQgCMJkByCofMVfzpEQStbE3Pi9D0dMQONTQIIEk4JkNBZdWS8Tj3s9LHPdLKvRy9yBQKoJitK8rKuq8daL8+j6oQStdGa3dWvapLjTtWR+KtKlZFkJZWt3FLG3QjKJsvKbcNy2bCpKrlRQfEroj8HAUm8Cgaro5MAq2ykdF24k2t0Q6ovkU5VB3MlFkrPQkvkW7JLGt02yenC3J7VQ5oWz6Mm+nBfv+nBAa4VaFRBmc2OC7Uwu2CLOuYzV9E0JClCMPQsdGs9Mvx+S8Py97SvJ7wfr+gGga-Na4VBzbGshy09phjqeNkQl+JOktbB0UStGpYbUOFjDHuw8XXtKEmPu9EIEnKIGaIZ9bVdGbaNZa7W4c2a0kNUJC7UWHguqpIW0pFm25NchTJfmp2ohdt26e-WqNtVNY1F0CPtQWGstCOnQKU1MkdG2Kl0YPIbLkt2Prbx23E4lt6U9K13AU-LPGf-X2of22HpjLljQ6rmvTkpfMY9PFusIT6aicd7vyhCABFBIch3igWiIdAiFUKgqnUtgj8jVQ7Obh7W+Xl6ZodqXPp7vwt53neEFQPBGnQEEkw9GBl7JmJsWahV1OzQ0xpDi6gtAsPQpgQJh3nvdca99sqP1Xi-Z2b8P673FAfI+J8z4EAvkQK+N8F53yXpgwm+E16vw3tvAh39f7-3UuIIB9NJwq1AaSTUrNIH6mgbrC6p0eaXRMEcYkqCHK41oc9ehydSa4OYZ-cUrA2EX2lBCKEHteHTkHhDYeAcx5RWmNsVQewDQ7mEggxQcicYyUmgTJOndVFpzwSwveKk1IaS0jpFoek2ikFEEkOAwg8CwDADZKhaCFHOSUe45+XcmH+HwTvYBfD-xBUERA8KojNjjAnijLQ2hiwKCcXHDBySO6lG8BEd+ABlMINMyqeAqlVd2-cQG5MseaHMewSymBMMYTmB5MzQ2mPMMBdpqmLySW4+pqhmmFAAOohCKBEEqoQZZywVjEocEYWDsFQBQzhrBslGLBuMPYFpUTLFWOsHiA1iyZh2JHEwyx0wLJoUsu2T9VkbK2Tslk+zKZ+AVgAIxoAQAgWjJRMBDNcuqowiQKAJAYGZetw45mNJScp1iJgsT4pdMk5tG6pWoegxRyz7bAoiJs7Zuyvqy0hQrPx6lNLaV0gZVA0YIhwrCOQZFVQ4kjVvrSgF7cGVrKZaC1lELfoA1RTnRARJ9RYopGbY2eYCXKF3KoAwS48TzCOCoP50rXGAqJo0lpbTvAdK6e-N+FAuUBN5cEsCEqm40sSTa2VQL7UhFae0paVV07+DVd7QKliNTEktAcGeTFuJB3LhmM62hSQIP1FagNYsg1E3lcysFoQ3VHNfMwVgHALmAIMb5HJYNKxLFMQdcxmwIKEk3BiDQFSFDF3zS4wtK98IlsVSyN1sL4WItFSiht2dY1jCTdY2wJZFCIL3JHLEPEbTKH4raRBgkJgaCHaLNuo6PLjpZZOt2HqeVBP0oZMAQqCAirwGK311KEnDovVgsdIKb3lvKDGmcCg2qrp5hu-MhgLpHWOPiDQwEWIUkulqM98c6EpMZaW1lWEkhFCjRUadCKpRnzwAAKzhVgcgoHjE7U1tDdthY9YHs3XaPc67MYW2-fI39D9lECmvWW1uBGiMUBI1o6F6lSBVBo3gOjtylz8SGQg8YZINBppsPoDUJhdDV01vu2wGHan0qBcJvDHoxNupInUMieAKJdEU5tA0J1Q7aCMIafUSwtMIAzfIGYVdKnliSiZultqAMKqA6Jwjbr72BL5c+19QQf5gFIEQL9d0+PnoE9hiz57rMgYXQPJT+7NSWjU1xTTxoTjF03Ee8pB4mK-J41l5xOWsMrMYc7ZV8t2k+MIUQQ+x9T7n0vtfSV-r+OdYZd1tOvXqZOoG2wv+ACuH8Gcz7GZfstbMdee1YlaH427lOJS+sfqf0dbqbNnB82KZUwBpkwbw2SFjYoRNi72XMPXaBXNp1C3HvLZ-qty5CmNs8MbTctW2222jxgcWDMF10yaEpHuQ1gtWvYxqeFotDDbv-fu31pbGiKBaJ-jo6F6B0BYB-twYrfTbk7AeYsJ5vad2bCJIaax+xSSecWHMMLMrL0eNTgT9lD3+sk-i16-SoTwmRNYDEzLWPFmBuF6kzxYu5aLae5thqMPGMjx1hzm0gykJ7jWPGxYgu1f-o8jkJISQIhJCfHkAAQhECIyAfBxAk3C0jzA51VD1wgS04wCR7lJCWaYhJ90wMjpm1q5ISw7kHZjq2-zbeCdKA7p3LvfQe69z791qluUJeCUl4VQflcZ+tSOu3Apc-O9dyEQv3vvBxBD2HjM+6KQbpOrHjtGrJgZg3a1SYbU+0nRt-X7Pqg28+5CNEIITKmSt89+333IftjpmsUcGse4tADSLOzmwthSwHGruqJYJgd8z7-XPhfHel8r-WWvp-W+IeLpnHxTN+-ljaDH4nA1YRyVx2gIynAUjVy1hUptbY5C4N6lAf4v6r6ujr5F4d6Ky9JNqbQ75-6RwAFH4brAG7qwawQGjEgLCGpUj7r365YrLIHL6r7jrzTNLvwf5+4zpSjIpqRYAh5Fh4ihwQTm5zBajjA1Z7AqZkh7A1hX7qh0EzZAqMGv44YhCsHsEb7F6SZSjSZqRya0b044GjAlLIhzAs7oiYg1a2Aaj6C6DDI4rqgY6wEq6Z6z7YbKHMEgrqHoGb6VA1B2bkQdBOaGFQ6jBJ7mgx6TCEjLBLAILGiWgBZhziKEgqCowKE-ZEweFv4sGeBsE+HF7S6Pr8qCpwopZ4BpYZa2STaXbfZmaZGaHP5MHZFeG5EaEYGd4hFopyAKCmGPIWEvKbCTBLgzAQQmxKDphQFnbxJfamYRYeRZGqBhBJA5CpB5ADZlQRBsra4KxEIjakLkKULVEzE47q7z4NFxAoFv5LErF+BrEaIbFbGQqLYrYcL1p8Ah7jCTDM5ojPKn5bAs6hzm4XQYjaDX7pF1H4QLHXGrFPYPEA40z7xDbEKjZkLjbTHta1FzEChQnLEwnrF+CbHwneAvFrZXLg7YGhGIhfEojmG-EwK7hTBLi6hUhxQTDVzglYlIHnGXGLG4m3GwkEmPES6Ay7GvaonvbonwFZ7uHclNG8k3F3EEJwmE7PHA6vHrbvFKyexGHdFHDfGs6WE8TLBNRGAcZoh6gNzna8YYmzG47zGykqHQn8n4mEkqkKyIpUTcoIBUAxgQC8rpYGEUldG8RrBIxDIIxJqxFHTFzmi2CuYDQTBIhiTOG14FoP4yntE8lOmKk7zKni5E4l7+IPp8py4EARKwBRJK5VGfY2knGIFnGZlynZkCmun5mLYfE9H6n9F-FPKJHSG1w0Gawcl2nYkOmeEKrNIJBhBhA5DNLNJCkFmikokHEfbWlSluEMFjnNETlTkzlzkLmqnsKklg7vGdHqomhISIYyJaheZahHQGCDJVwaDqjFgILDmnELHjqTnTmznzlEmcEB7U4fFM40k-Fs41b6gBYnA8wmCgTozcYplSppn0EMqfkgrfl7l-lukInaGB4frzpBnnnjAGBdl0m7pVgEg1iIJHDbBISEjvn1loU7k-n7n-mFGJYCovpV74XirVlrmq4bmoVbmqEYW-kHmqpnlLp3K9G0ngXkWIJIxUUQS6j5inAIVWlwECXpmbmNkqFfm7liVEmrLfQhBN5JAAVaI+l4B+k6QBknnKyUljA7gyVgWGlBymiPnhzWhzDFxIQMWP7CX4aEYZBJA+DEb+5aLkZUYEDybb4HDIgIKmhUHQyTA9nEhqDQH7THCJlTFHG1kIEBW6Wr5BWiihXeDhVcEIC6GyaxWSVgYkqkVyWDEn4EjfLIxUF0ULD+UZmb5Zn5A5AVSlVhUO4UAQCsCaSl4BKSlaUoVKGBX9WDUhXDVJDb4zzaoMnqhLjxRHS6BqBKD6DeWmgrAwEaUuF17aVCVFVXELXIBDXlUjVjXlGqCTWaTTWuEXVzVXWLE3V3W3ErVf4labQ1imCZhLh2HYo4o1YiQEhmxIQTEsS2HdU6W9VNk-VLX3VJBMg9IOXBmtQDTGrX6mhMSgnKASE1iTz6AzKGBUGDRI2XUo2Olo1lV-XfUDW3Xo1-Whp-R+AJDNKjXjWqBqmyirmaXvWzX1FfVhBM3LWs2LXM0O5c2pC80kmg5AJ1X-joxwKCRtQyEaBKASE7jqCxEIzaBrDGl02fUM3FXS0Y2y3s3y0u5sFK181Ln7Fol5XrkfUS1W3XVs2-UO523+2O3c3K1qnHlq2EVLqa02GII62Rx62RSDFUEBZWgIJNblKwYW3e2L5ylmUhBFSeDRDRAhDe4RDNLIAWVShAXq2M6aCNVuWIDVyWIU3nQgTFiOLp5IXTYZH4R52+hToRXcFB5d4boagaC85xTWj6CdSWKj6U0MmRymjJmnWpnd0Qn26O7N7913ovXl5PqcWvrvqfp8Wi3nXi292b357dhvwj0Qbj1LiT1rqdTqgp2U3t1ITL1vVn2KFEwRrvxyloF-3Y3amOUKB11bgYj6jEg5ik08Soj5x0WzBkiwwd2IVTZXbr0Ch-08mAOdLLRAwA0M5A0m2bjZhjHQMGjGjlIXSai4qiGIIDq5U1me3n0eTYMAMbxAN9w41EUkMQPkN5iwObB2JqAowx7OXLgnVf3IU-34TsMqG4MupAwLCR1gZ8NkNQOCNUNT3qAbq7iGjKVGBMP8Vi2yNsN4ORpynjo+DRCbEDaV0IBRXUaBk8NLr6NTDlzkgnQ0EqBUNGABYsnoi7WWJp5oM1G2mnHyPjmbI2N2Mk64XVX6H2UgPBlDyG5mKFgQT8StQQEmyo42hZ1yMWP-16UgqxNPZ+GkSBGUTUSqP-jzDDGmBMR6yEiIKdRKAp2j2GC5hmwQGFPmMuo8nWMxBxMEKFll4y7FFcUEBlEVE15d0YOcmqBRPbkxMjO6413Q5NTpN7bFKoyajEgH6mDjATD9NYPFNZl8k5l5Buqu1vaHHMMzVmPnODNNlXOwlvwq1vEh5pP+y7M4hDGahwTFzVwHBLDGOn0yM90DPLSXMKkfNux3PikPMmPf3QsvOwtvPwvrGfNh2q3kmuMzjqyw7G5yCUiDLEhH52g2hUFOEr0LOYkjmlArPyl4n3FupQDoCOOoCqQh5R6lgx6zBHDFi2ALDaOtSVw60nT5hVxnPMsXNYtstKlxa72TOlnlmVmxIn1nVQuYPyuvOOnvM4tFZ1PNomI7Nw66xJRqCGyOHwTFhyvLMKulPMWYXia4XV2mvQ7k0WuksIDzB6zc5GCR5h4x6Ossv6UsXzkqtFl71TOH3V7aur2LNMtOsGvROhoGX7k32bNbYMZ-OWvCPWhqB7DMRHDRQOud3oOMuRPOur5FQRAJBu5BB5BS1+0+Ck7cGekaQIA0B4CiAh6oj4iaxVwsSWKzBUOmgBYmowNFja3ht1tv65DvzO5FQK3zTeCzmdvMDdtgC9v9v6Jes+xGYfKILgQWF-H6YluINEglhE0Lvptv5u44CDWCkBjjOepFGTA8DzPVsRP1ksvPuvubEBiDu5iQxE00srA7iUNwOp7qAIaIKGjlzIRVvhN1lz4RsgqpC3HlXOxAaVMBEOZBFUR8vQUIcmpj7ARUPeO6OtQQwXRdQPuYsuubI4cPifQEcJMyZJM-PHUkuByIC7hUGZgKCH45ORHMeWOschDsd4dpxceD2OPkDRW1VHuICWJzCrr7oQyL3zBUN4glt6OOFtRzDKBSclMZtyecdlofvFkV4H2lGpbpa-vocFXYZYcKrWf4dlp8f5u7aFtCfX4zAKBrDKYrDT5ofHHucrKeebK+gr44BFR2dxtUg-tJsMv-uYeLuqEJcRBJeDtwS7SjvoxEjyBUPwdLitMRQoddVRf5XSkrKFBBBFTOr4PAigjgiyiHuEvGJ2gCdD4miX4fLgGLCEj6h0vSNr1LPNetdAMddShddyiEM6ngytq+uCdjAqABYUgki9ozIDSOuzdtfdLcd6Fqe9dgwGCXShyjyRyGC2Glw8QrBae0tm2iQUiWlTcpunHHdANMC7u6Ldf7sDu5v64+sFt+sZ2Qyc5mw5hJQ35HcRAtcncVDsUOclFvqJvfc1v1l-fFP8Gkq3cgT3fgSQTPeQIfKcaLA7B9P1csPPOlBEnhA-VuqPUTWxs49ZfYbM9tuDU5vqf-GUjrWH66gsQ1gEqBsqBpfphmy+WTce1PPotM-YVOp8+3Vs8C271c8Yc8+q8s9+030reOWTDByUV1wcYQTlc8QtoZhw+5iNStTjCOu8+s-lBY0h6TBKD8STApWO9LCFgYgBNmzQw5gyInAu-6-q9EYe-G-Ble+VgEi7dFj+++amghy5iXSaAm0nAQs6vTepuu+G-u-5ahDNI5AtthDvz-mVrDinK1qRj4uC-NNadZg4qDRguFi97GqmDCQrDTyR9tmPbR9vyqHRbl+V-V+q8ONIoEWXebQT5mw9+kjA0I-VyFiHClg2gXTCH7SmiD-bHtIj8l+AYiYT8DVT9D8Ino-72Y9H0hiufReNcMpF-88n9RZn8V8X-iU0ye8sRL+bpNM+YSxOvyihIcsU6YaGJ8UrAu9uwPgDIAkHfiVQAAmlkGS64UnGMVFxik3PJUErEOKO0KSioJMQnuHOUwFMENQbp46u1IwJ-UV6mNlehMeAYgJLo5BUBSXBxokwu44Cl0sRUsLDVzBo48QCeKCJQJmDlwmIeIGxFI3oFos9WTA7wAgKQFsC0BhHeoLKEsBUBSAEAbfMdEUrgYhBMhUgQ1HET1YZkR+A7hoFQb0s-2uvFZL6GYHKD2ByXWzPUGqbBFBextSuGHDvYKAN0ogsrD0y96Gh26dXMJk-0EpAoHBiglgSgNUELcgecoMHlsARwzAzYhAuCExENSdQwEWKdGFTVzBNNYBPwRwawOcEpdJmleGZs50qI68YuL-OATEKcFoDt8vUNIbISIFZDjBCAJKEWFihQFbChqIwI6z+ysg12wDQxMGWkr10BiGqTWEjGvzWgMYNodSnUOf6-Z8cYw8UJnHn7GEGqoFA0rMK2A6pYIuoE4ElArDmd6eSveQcuxCDlM3cyA0UIUE3aIkXsy5d2o8wYG3DI0Dwp4RkBeE5AvmGpPzjtiYyBdjhJgWhpWBUD6hMQEER1ncL+HPCogmiKUOTi5aU5qctOYCtSTMKuUjhB4YYgeHUykgGSDiREb8PWaPCURrwm-iEjCRlkFc0SLVmsMiFEwkR1I-4YCNBEDd48gbJHAaBNgf1TAjrJolsJCBb1ARHvZIQeHuTKVhOlIc3GK13TkckM8ac-NdGsFsiva+EcUZEDXaSj880o10AQ0F5ztNwl0KIrYkGiWgCUoLWCK1GXBw1rQYo1-BKKlGojWWzpe4szyKAJAggAQDIC2woAy5vSpAQYDGEHZuZpEZnRjAeD0BQRSuPaEfMSCQa6g3RCqA0XkE9GbtvR1zH-k6n9GBjPAwY-4G7HZ6C12EwtHUawwFD6idkOY40V6ObLrE-RAYoMS2yZDAiySp5ZvrHgEiII4R6oE7ImJt7oxSwBgVNLMn0BXDwhDXdkXqPdHZijRtI0oK2N9H69ixnY0oKJX3LNl-yHpNLD2yso2U1IRAbAZMPPI6dSwA6Sgq1COqUgkx+gcQcWEMA7hNAp6a4d8KWYNjDRuYpnt2CyABAOOoaDZC+GHBaDIxhAbfIYCRgx4yQJA1YEIw05rBzQ+gdGJtV1DxRMxmyFcQBMJjATPAoEktJwJ47cCrxS6BMVMAVHjsqQLaGBMQIQ6j0X65cL7rIN1a-jlxjY1cQCK9G+giJJE8Ca4PsyOZSOso44MHxObWtRiSEA1AcCRj0dCUywUZLhI9HNi8xAkj4EJKZQONMBFEyHMGRNh29Sue0D8fun8HPc+Y1idGA92LiGodwak-CRpMAk-BBJ5VMCbpPpFVDZmLnDLrYPqFAo-xTYtcYRO0keSS0IeOUTRJHF0TlRUEJUYpWXCO8cJ34uQVxKzE8SCJyxcvu-ACAlAJhhk3AXBP0aITDUyEglGcEUohCY8rdJyVlJckiUs285bcaWJbaFjqAJAQgGREfRRSQo6gdEJoBERCQkxu+Kcdmngq6htRHEgvqcWCm8TpRkbN1q1LLEdSPWfBWUTBgJqQCiQ9EyxFBDxBQUIGlIKgtAXqn-jGpS0sSitPan-lcKs-YPJtLrq0Tdp8U57kvVu5L0twamdiV8PSmpt5pBEq6fuRul5A2KqrIolUPv68VaxjPVQIDMunoVmpWyDsW1LBmq8opohbaYqL2kqjNgaYlTEiAGTGBpE50kKXxLzHAyWpqM1aUZVNFIsVysMxgQjNClUyUZJY2mar27F4tvmsoi0U0175bU-BeMhqG1APTHBbAM4udmTIWktibaf1Qqd-n-A2hfMY+DUHD1JBzBCaefZNrjznwsyKZ64+WSNR2E8CZwpISGCiArD6hI4XvAlAkWNQbpap5SK6L9NRacSAZ3Ei6aFJKoc09JKnZxsk0okzgneocS0MdRhi0UqQUEcYD72z7eYDghqOcTYLc7rCiYBs6Ub7OZpkTzul4oqVRP5jYy4pDEm3gNACxQMEEDiDdGEJTkRDdRHkDOXLL9pBjW2jbDGorMBphFTQgWWwLMEIEUgEMBKQ5samODkoDwIEaaX9I9lzSvZ5MzOT9RbmshXYCs02cHI1rdzSQvcpBIYCEEEoyQFAvWOMBOhbUTYjrHKZGnyk5BG21UZIXwP0GCCEMRgmOV8Xo48xDgveBXlPNmn1lvCgpDgtvlorqB98+wBGAwysLEgjaTdAeWbGRyOs86YEGfsPWSFKAJg1iAAoglLbVyYEuYfEBgre795KwOszLnYIZTwLDAFQyGY5yx48VH+C4+uY3kvohAwII9VBWiBYiWgdQiwbBZaE3BxRq56OKpGlOnn1lS+snPwLhy5D+zKMgcvjt3I26DcwGojGPG1GdHrpHWoi7zlEBzk1U85SssGJaHeRoZgaCMXadb2EbCDAShIeyb1DWDqLT+rKTRYDBEnuDxJgvEwExGNSLAToKwFQFn3aY7RgSk9TIcnKZnyCNF4ijjt6AoUcVMevk2oTNJ+4iL7FLIRxV3lpahwZCB4ExbPD8ZWI5gFskITWD1hwKkSRACyEQDECyYZ+6AaTGfCgCoBgKcEg4d2RgRoZASxga1rfmE4lLhs5SypVUG0W8dkhvzALn6wQRJR2lJgXtKPNzA9Kj4fSsgAMtwqnj-SF4oOfnPqpNL8Rhwv4g4imDx1lMhqRNM7yEXfziYxUK+bJznJVQsalYoWq9QSV6y8oFyzYjgGuV+BuZR5JvgAp26IQEM7EWXvETtC6ZJJ5KQ-GbH8p3CggOAN3BX1uUC17lItfPoktUBQqYVcK10D2JPIAL8QSwVInrBkSQFBubUUsKdKopZLiwJsT+e7LOWJcC6z+MNIDCqDoBtBtOcMTAD-6Dcem4sifJfjvZ0Cv5KKulYvkZWExhVmBaTHZi0EcrkhY3B5LMGYg7AbQ8RLJimJYh8rTgAqmlSiuWIc1UeEoUEFRCoBdSIwS3HrmbOVkUh4icPFMUOJ6LH5-Kuq5mqj1RWRpvCNMKFIEEBh3LqxDywVXrKdVhUXVUK1orJ3KqhUaYWKiOrsLkAxR0Q4ES6AZjMWBR0hI83PhdBvzDDTlOqnIHqr-rfUaYPwXIJu05A5BWuxUfmk9URWhLrwgajyfmqlqFq8gxah3KsXLVFQo1G2ZBTwpxQKBJBKk44NavJpTjGOiai1P5Wj4c0Rqk1OgN6RNUtBOV8RLUOaHUxm1D5KCidcbMxqmiopR+dQOfhBZH4aW6MKCBFFXTqinRecTdX7SnWY07hTtHmn+QdqVrNI1ax5Vl0nUO1XVLSEOk+uWqdq+xMa-1oanWoqAH6hwfWjbzPVTj0wzEauJdGvVy0Za9639UHTeHIk3aEpd9Rh0-XIbI0D63mkHQA2DsQNb4l8uBrGRLrq4PacAsbGLjoZs1es7DI3LzG7ELIMABxp6yA2m9IYIfKaRajNKS9jANkpUcg3Ay1g6weAdABADgCSB0SQGgALQGAJCGoU6SShgY7BT5jG-9kBsTqN0YI0vaSg5LeRuzIWZylJEBvEK6wDQkGDTDp3LhLBHWroIDWpkhhkbReQstPshwWFgszON+EJdhsClEwlIvIbjRiHLjm8IYZofUJk366IQTgZwBLaZuRVMausmwv+pZr7QzAzUp02rCbED7dQcwaYVDAyWpVmaUV2GUYUSV03e9KKuKYwJeRjycwJ4vQ2yekKugjDNhb8GrbMCRgHUjGIiI-EdFz6QKswwA44FpvnEM9GBow7xBoiA22g1AIUTVCdBM6FgY8jJJDBFEugrAytKW7nishDSMrUeC28lGWB1qpFi4ZsCZDYRSrEgN0WSuxR-yVSE4AYLm+KCL20Bi9tqusMPqHGhhmdem8ybTSQuDRNJQ0jqVHkRlO1wTvp7WlYMqqNLlxSVPmQ4IcFRxfiptNwpZqIu60WrGcRKZpWRSDinBzQl+eDQIKQh7bdZB2uVMkptiFZ-AlmsBjMJ7Ln5QahA18p+Op3EKgteONJD1n14DZMt4eNYKbWZIIwnx+2EDTHhrAdUo8b5EHXzo3p54W8H+BbfsFBqcLlF9E+POqHKz848wpqSedqtS300c6r+d7Vqnc1fbPNMcyGKaXKRE0yVqwwLWnMhLCU0C6u-HbgVYyfbNq4vXzFEXxBrp90KfCYq6KV3u77SX1HInkW91rywYx+AJggj7whCMQxceIgjDAKk7I4liYpVHsXEx6fa+YlsoWKA1TiQ9ZwJYAXF6Eiy-M+oDMKaUrmNYfFjrJipsj3FYUr+3gCvVnyAUDyaaLs4bZilNITiyRyddvcJTZl0zygFe8pAmhUCHAB5kk6MiWBbre99MywKfbHqRlRtCxxlWWKZUvoV6Vg-EfRgkXA7Wg9NfmMri3SFbaBu8O+kvVnLCoubgI-u77RLyNJjsKaeK4EvMHoqF76FXJSWluor3GltpTEE-JS26GitRGsREmUcH2parytZuy2hbuto3qv1zmn3WEWTpQGRWtrOA-ZIppFhD8oJI-M-swO+0kNttXDRjUVqPq+9kyBCfrF3Ckhk0EhUMs3rJEnS4a1BxoozWwMy0G2m7SzeBHaHNYIIRgbg7eOkJgqoFNcmtamwWJ50C6RdEup8HLoua1Qk8CGBaiJCZ7VRIG4tnaHLgztMdtcuhXWJzyMLt6TOvA4FCQhTB8l5cB3kNL+LjAoRtrKlftAj7AHbDabFjkyks2wxWd7TY4HRy6bBxQsgRuGSy0UbLQwjKwCI3A1C7qAWm++ROTzoCnR6MW0nDNuU2F1OH-WRXEdhkPHbJr-WLEMnXozHZWjDgFnOFkq1zJ47E9m0M-Qmn3QTBTgMhKhmHqRhqY0MluQ7vEcYFxdM2++9oxssHgOIbJawPTMlTaZwMiwZuL3gGw0wm60DtOoFCywbZNt2p0fHwEBpPQGxEy1+SIrIdWOkbK56mEFpanGPyCWWdw1duux8CzkgN1YXFaaDA2cGko3QnYMFD0bmGmSYbJ40s0A4vtbqb7QiKcY22ZhwIeenxihP9ZH4U6iHVPT4qIV5Gi9BRyzqszEUSKfOuyL4ycNC4+UfK1oCrqGWPwziW0MyZo1YxBR5ckupxlDtzGNIQQrQq4YRjuEhhVcDwGehGKgf22g6iY+PF1C5pmRQVsUuqPFNUYtwCnR6RYPdOOwP5PFh+bvRwx0cYiP6BTJsKQdT3r2HA+hOKC4UggfIanhSBvN-v4CZBhboG6gQ03iGNMFbXDxzMQvkrDzWmictpjXu703YAANH9bmu43Ic1AW6OMfozT4J5FKRwCYANATwBGsdP4wvlH21MfLRF5-KvuXtKOppA2NepHOQZi1RQ2JSMCAsWBX5RFiheQUoXELZOlG5Rk42Ka9JLmbAVAzda6AG1RhcROtAutONmKt0+8zgHmwPTAg6Uw0yQL3MPXmghOptORtjVvNyNRGZbDaptKAjrW2Com9gRKPYDtMpaL1cjqcvE6UBY05AwtY44RlrMUkPiqwPTUUzTvFNLjMp3sw2Q6fzPf78Zi9PIS2nRhe8VgMsgiRuKVLtiOZLbU4zmF4V6YaWu4BMQdJA1TjdApqE2JHtTP-SZ5r5ueS2KNabie97MncR+d1MNQjAHyC6JLrzimokx4DCWRmngrGZ5zmFvCQ1J9m4XQLW4mmV2K73hB3m1W-M3Kq3BUt4qMC1WSWFcO0XtA9FmQf6t2PpzZ5sszSUBPCktINkIuh5HqARwhM-iJ02U9HlRD0dlDbu08-DPkvZTZyF8zwCUG41fmNONe0GoagoJvImjjF+sueaan77QZeZ4i7OH2oDTeYj+m0JZI7N7ANY3TE7AYrahAXEZrra6ZxfRk96iLsxsGG3yBaN6CCC+m-Xo1wUSX5gCq483XKCNuW2ZnloyuXyP1mUgNhpycbeyUBEgLcuYJMXuqnG2BJLeVqKz7PAOlGPt0RfllSCkH17OD+Ia0H3iPyzJHNLl-WaZcamv7yq3Gzbkhg1AGAoC95gaNJdN2yWXzzFt8-PObmljW5y8h3JVbjzPd0QmobMBWCyY1h2r75tjZZDACZaAszJE4KYB3yj1JehtXpomonHX6z55lvKZZavmICXNEG8rPBHHzI7shNvE6LePD7SJq9jrX+ZsQT1JXcChILfmcE8PbBSuVhOumdBCZn71McCxhWBFO08KqVfA7FHEVeQQFYICCISPR3kITW8s9Ook5EqiA1bcw+6-dEsOgMzI-GXOW2RPieTIc5lZS9LP0sgtlYrBTJOGtsBgR3tJlesYwIaD1j5WbDdCZ5Wu1eXvLLN1Rg0CBttB03iwbUSbdYem0ExNblyt5blMSt6KF+VqniOQPNBTiHeOYRMslqfMFVLb2tm22IYvOlG1KSfJNCzmLhqggVMUYVsYCPSpE1rOxjDmithVBBdb9JXYOfnz16hMJhlmS-HbdXoqggttzuamGJXox91VIYUbQNhpq3zb14BO3Cr9uWarE--PWlaA6U362o5oMlantBbDj-K4qi4oyuTuO2lge1Cba5lGSod0Lwi1QH3Yh00wC7RDRiNRuPknAjAGIEJkNsdt5g01GEpW6FF7v5d6V-dx1GKoPs+5Kr8wSiohEnxayuVylEeV9vcNNNtjYpgqjPdFUF4cgtjZYpZr3BIwGTMMN20SBVX66lrXEMPj9Ymt1r-rUpgO3rcgLb3dzq9+YI6tzXOr81uB7y6+U1CfckoK-ahvp0duRE01RcOYJaBQd5rim36tQqGo9URre9pRvYPiFHkZ1VTlBa1RHYlnJphBZIch2g8oeNqO8zah8K2tuLtqvj8o9UMdkOZTt2HPK-qJdH3Ox2X7WeKBy6oocwPMH8G1K+vfPw6ZZHKY+R9w6Uee2s8DBv6oPY7Ng0015wo4JHCoKIb7aMtDByjcYgStpeZ7aKDuCKQNRbEt3PRraHNQe3edpjrdVQ4I1-qMaLmhSbGINCZr5ep60iycF6g5gSkV1ia2Y4Dq5Sg6+dVIDgF00mwyLJ0VDEh3zBQRjAw7Y4KZxCsH4HHQdYytXwdrH6Xcm7PwOsmdzIB8nC4WGpHjUo2hBuSBtNQaCQR8QhoDgIAA */
  id: 'KioskAntrian',
  initial: 'INITIAL_CONFIGURATION',

  states: {
    INITIAL_CONFIGURATION: {
      entry: 'setCtxConfiguration',

      states: {
        PAGE_HOME: {
          initial: 'INIT',

          states: {
            INIT: {
              on: {
                'click:everywhere': {
                  target: 'MENU_PAGE'
                },
                'scan:ticket': {
                  target: 'VALIDATION_TICKET',
                  actions: ['setCtxTypeActive', 'setCtxObjTicketResult']
                }
              },

              entry: 'setCtxPageIdle'
            },

            MENU_PAGE: {
              entry: ['setCtxListMenu', 'setCtxPageMenu', 'deleteCtxSelected'],

              on: {
                'scan:ticket': {
                  target: 'VALIDATION_TICKET',
                  actions: ['setCtxTypeActive', 'setCtxObjTicketResult']
                },

                'select:menu': [{
                  target: 'PENDAFTARAN_CHECK_UNIT',
                  cond: 'isTypeBooking',
                  actions: 'setCtxTypeActive'
                }, {
                  target: 'PENDAFTARAN_CHECK_UNIT',
                  cond: 'isTypeWalkIn',
                  actions: 'setCtxTypeActive'
                }, {
                  target: 'HOLD_TICKET',
                  cond: 'isTypeUnit',
                  actions: ['setCtxSelectUnit']
                }],

                'click:anywhere': 'MENU_PAGE'
              },

              after: {
                timeToIdlePage: 'INIT'
              }
            },

            VALIDATION_TICKET: {
              entry: ['setCtxModeTicket'],
              always: [
                {
                  target: 'VALIDATION_PENDAFTARAN',
                  cond: 'isCodeBooking',
                  actions: 'setCtxStrKeyCode'
                },
                {
                  target: 'VALIDATION_UNIT',
                  cond: 'isCodeTicket'
                }
              ]
            },

            VALIDATION_PENDAFTARAN: {
              always: [{
                target: 'VALIDATION_PENDAFTARAN_QUEUE',
                cond: 'isHavePendaftaranOnlyOne',
                actions: 'selectCtxPendaftaranOne'
              }, {
                target: 'NOT_SCAN_TICKET',
                cond: 'isNotHavePendaftran'
              }, 'SHOW_MODAL_PENDAFTRAN'],

              entry: ['setCtxListWithType']
            },

            VALIDATION_UNIT: {
              always: [{
                target: 'SHOW_MODAL_CONFIRM_UNIT',
                cond: 'isHaveUnitOnlyOne'
              }, {
                target: 'NOT_SCAN_TICKET_UNIT',
                cond: 'isNotHaveUnit'
              }, 'SHOW_MODAL_UNIT'],

              entry: ['setCtxListWithType', 'setCtxModalListPendaftaran', 'setCtxPageMenu']
            },

            VALIDATION_UNIT_QUEUE: {
              entry: 'setCtxPageLoading',

              invoke: {
                src: 'getInfoTicket',
                onError: [{
                  target: 'ERROR_500',
                  cond: 'isServer500'
                }, 'ERROR_PAGE_UNIT']
              },

              on: {
                'on:info:ticket': {
                  target: 'TICKET_FLOW',
                  actions: 'setCtxTicketQueue'
                }
              },

              after: {
                waitResponse: 'ERROR_PAGE_UNIT'
              }
            },

            NOT_SCAN_TICKET: {
              always: 'MENU_PAGE'
            },

            SHOW_MODAL_PENDAFTRAN: {
              entry: ['setCtxModalListPendaftaran', 'setCtxPageMenu', 'setCtxModalOpenOther'],

              on: {
                'select:confirmation': {
                  target: 'VALIDATION_PENDAFTARAN_QUEUE',
                  actions: ['setCtxSelectPendaftaran', 'setCtxModalCloseOther']
                },

                'button:cancel': {
                  target: 'MENU_PAGE',
                  actions: 'setCtxModalCloseOther'
                }
              },

              after: {
                timeOutCancel: {
                  target: 'MENU_PAGE',
                  actions: 'setCtxModalCloseOther'
                }
              }
            },

            NOT_SCAN_TICKET_UNIT: {
              after: {
                500: 'MENU_PAGE'
              }
            },

            SHOW_MODAL_UNIT: {
              entry: ['setCtxModalOpenOther'],

              after: {
                timeOutCancel: {
                  target: 'MENU_PAGE',
                  actions: 'setCtxModalCloseOther'
                }
              },

              on: {
                'select:confirmation': {
                  target: 'VALIDATION_UNIT_QUEUE',
                  actions: ['setCtxSelectUnit', 'setCtxModalCloseOther']
                },

                'button:cancel': {
                  target: 'MENU_PAGE',
                  actions: 'setCtxModalCloseOther'
                }
              }
            },

            SHOW_MODAL_CONFIRM_UNIT: {
              entry: ['setCtxModalSingleSelect'],

              on: {
                'button:lanjutkan': {
                  target: 'VALIDATION_UNIT_QUEUE',
                  actions: 'setCtxModalCloseSingleSelect'
                },

                'button:batalkan': {
                  target: 'MENU_PAGE',
                  actions: 'setCtxModalCloseSingleSelect'
                },

                'click:anywhere': 'SHOW_MODAL_CONFIRM_UNIT'
              },

              after: {
                timeOutLinear: {
                  target: 'MENU_PAGE',
                  actions: 'setCtxModalCloseSingleSelect'
                }
              }
            },

            VALIDATION_PENDAFTARAN_QUEUE: {
              invoke: {
                src: 'getInfoBooking',

                onError: [{
                  target: 'ERROR_500',
                  cond: 'isServer500'
                }, 'ERROR_PAGE_BOOKING']
              },

              on: {
                'on:info:booking': {
                  target: 'BOOKING_FLOW',
                  actions: 'setCtxListBooking'
                }
              },

              entry: 'setCtxPageLoading',

              after: {
                waitResponse: 'ERROR_PAGE_BOOKING'
              }
            },

            ERROR_PAGE_BOOKING: {
              entry: 'setCtxPageErrorQueue',

              after: {
                timeOutCancel: 'MENU_PAGE'
              },

              on: {
                'button:cancel': 'MENU_PAGE'
              }
            },

            BOOKING_FLOW: {
              states: {
                INIT_BOOKING: {
                  always: [{
                    target: 'ERROR_DIFF_KIOSK',
                    cond: 'isDiffTypeKiosk'
                  }, {
                    target: 'CHECK_PRINTER',
                    cond: 'isBookingHaveOne'
                  }, 'SHOW_LIST_BOOKING']
                },

                SHOW_LIST_BOOKING: {
                  entry: 'setCtxPageBookingList',

                  on: {
                    'button:cetak': 'CHECK_PRINTER',
                    'button:batalkan': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',

                    'click:anywhere': 'SHOW_LIST_BOOKING'
                  },

                  after: {
                    timeOutLinear: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                },

                CREATE_QUEUE_TO_PENDAFTARAN: {
                  invoke: {
                    src: 'postQueuePendaftaran',

                    onError: [{
                      target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ErrorPartial',
                      cond: 'isVerifiedBooking'
                    },
                    {
                      target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ERROR_500',
                      cond: 'isServer500'
                    },
                    '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ERROR_PAGE_BOOKING']
                  },

                  on: {
                    'on:create:pendaftaran': {
                      target: 'SHOW_SUCCESS_PENDAFTARAN',
                      actions: ['setCtxListQueue', 'setCtxTicketMe']
                    }
                  },

                  entry: ['setCtxPageLoading', 'createCancelToken'],

                  after: {
                    waitResponse: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ERROR_PAGE_BOOKING'
                  },

                  exit: 'cancelRequest'
                },

                SHOW_SUCCESS_PENDAFTARAN: {
                  entry: ['setCtxSuccessTicket', 'setCtxPageSuccessBooking'],

                  invoke: {
                    src: 'printTicket',
                    onError: '.SEND_ERROR'
                  },

                  on: {
                    'button:ok': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',
                    'button:cancel': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  after: {
                    timeOutCancel: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  states: {
                    INIT: {},
                    SEND_ERROR: {
                      invoke: {
                        src: 'sendErrorPrint'
                      },

                      on: {
                        'button:pendaftaran': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                      }
                    }
                  },

                  initial: 'INIT'
                },

                CONFIRM_PRINT: {
                  on: {
                    'button:lanjutkan': 'CREATE_QUEUE_TO_PENDAFTARAN',
                    'button:batalkan': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  entry: 'setCtxPageErrorPrinter'
                },

                CHECK_PRINTER: {
                  states: {
                    INIT: {
                      always: 'CHECK_PRINTER_STATUS'
                    },

                    CHECK_PRINTER_STATUS: {
                      invoke: {
                        src: 'getStatusPrinterUSB',
                        onDone: 'DONE',
                        onError: 'DONE'
                      }
                    },

                    DONE: {
                      type: 'final',
                      entry: 'setCtxErrorPrinter'
                    }
                  },

                  initial: 'INIT',

                  onDone: [{
                    target: 'CREATE_QUEUE_TO_PENDAFTARAN',
                    cond: 'isPrinterOK'
                  }, 'CONFIRM_PRINT']
                },

                ERROR_DIFF_KIOSK: {
                  on: {
                    'button:ok': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  entry: 'setCtxErrorDiffKiosk'
                }
              },

              initial: 'INIT_BOOKING'
            },

            ERROR_PAGE_UNIT: {
              on: {
                'button:cancel': 'MENU_PAGE'
              },

              after: {
                timeOutCancel: 'MENU_PAGE'
              },

              entry: 'setCtxPageErrorQueue'
            },

            TICKET_FLOW: {
              states: {
                INIT_TICKET: {
                  always: [{
                    target: 'DOUBLE_CHECK_IN',
                    cond: 'isWithCheck',
                    actions: 'setCtxDoubleCheck'
                  }, {
                    target: 'SHOW_INFO_QUEUE',
                    cond: 'isListQueue'
                  }, {
                    target: 'SHOW_PAGE_LOAD',
                    cond: 'isNotRegistration',
                    actions: 'setCtxNotRegist'
                  }, 'CREATE_QUEUE_UNIT'],

                  entry: ['setCtxQueueList', 'setCtxSuccessTicket']
                },

                SHOW_INFO_QUEUE: {
                  entry: ['setCtxPageInfoQueue'],

                  on: {
                    'button:lanjutkan': 'CREATE_QUEUE_UNIT',
                    'button:batalkan': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',

                    'click:anywhere': 'SHOW_INFO_QUEUE'
                  },

                  after: {
                    timeOutLinear: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                },

                CREATE_QUEUE_UNIT: {
                  entry: 'setCtxPageLoading',

                  invoke: {
                    src: 'postQueueUnit',
                    onError: [{
                      target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ERROR_500',
                      cond: 'isServer500'
                    }, '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ERROR_PAGE_UNIT']
                  },

                  after: {
                    waitResponse: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.ERROR_PAGE_UNIT'
                  },

                  on: {
                    'go:list': 'GET_ORDER_LINES'
                  }
                },

                SHOW_SUCCESS_UNIT: {
                  entry: 'setCtxPageSuccessQueue',

                  on: {
                    'button:ok': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  after: {
                    timeOutCancel: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                },

                DOUBLE_CHECK_IN: {
                  entry: 'setCtxFailedTicket',

                  on: {
                    'on:create:unit': {
                      target: 'SHOW_SUCCESS_UNIT',
                      actions: 'setCtxListQueue'
                    }
                  },

                  invoke: {
                    src: 'getListAntrian'
                  }
                },

                GET_ORDER_LINES: {
                  invoke: {
                    src: 'getListAntrian'
                  },

                  exit: 'setCtxListQueue',

                  on: {
                    'on:create:unit': {
                      target: 'SHOW_SUCCESS_UNIT',
                      actions: 'setCtxListQueue'
                    }
                  }
                },

                BACK_TO_MENU: {
                  entry: 'setCtxPageMenu',

                  after: {
                    100: 'SHOW_ATTENTION_MODAL'
                  }
                },

                SHOW_ATTENTION_MODAL: {
                  entry: ['setCtxModalAttentionSingle', 'setCtxOnlyCheckInTicket'],
                  exit: ['setCtxModalCloseAttentionSingle', 'setCtxBackCheckInTicket'],

                  after: {
                    timeOutLinear: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  on: {
                    'click:anywhere': 'SHOW_ATTENTION_MODAL',
                    'button:batalkan': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',
                    'button:lanjutkan': 'CREATE_QUEUE_UNIT'
                  }
                },

                SHOW_PAGE_LOAD: {
                  after: {
                    250: 'BACK_TO_MENU'
                  }
                }
              },

              initial: 'INIT_TICKET'
            },

            HOLD_TICKET: {
              entry: 'setCtxShowModalGIF',

              on: {
                'scan:ticket': [{
                  target: 'VALIDATION_UNIT_QUEUE',
                  cond: 'isTypeUnit',
                  actions: ['setCtxTypeActive', 'setCtxHideModalGIF']
                }, {
                  target: 'ERROR_PAGE_UNIT',
                  cond: 'isTypeBooking',
                  actions: 'setCtxHideModalGIF'
                }],

                'button:batalkan': {
                  target: 'MENU_PAGE',
                  actions: 'setCtxHideModalGIF'
                },

                'create:ticket:unit': {
                  target: 'SHOW_MODAL_ATTENTION',
                  actions: ['setCtxPendaftaranFromUnit', 'setCtxHideModalGIF', 'setCtxTypeActive']
                }
              },

              after: {
                timeOutCancel: {
                  target: 'MENU_PAGE',
                  actions: 'setCtxHideModalGIF'
                }
              }
            },

            PENDAFTARAN_CHECK_UNIT: {
              states: {
                INIT: {
                  always: [{
                    target: 'NEXT_STEP',
                    cond: 'isHavePendaftaranOnlyOne',
                    actions: 'selectCtxPendaftaranOne'
                  }, 'SHOW_MODAL_SELECT_PENDAFTARAN'],

                  entry: 'setCtxListWithType'
                },

                NEXT_STEP: {
                  type: 'final'
                },

                SHOW_MODAL_SELECT_PENDAFTARAN: {
                  entry: ['setCtxModalListPendaftaran', 'setCtxModalOpenOther'],

                  on: {
                    'select:confirmation': {
                      target: 'NEXT_STEP',
                      actions: 'setCtxSelectPendaftaran'
                    },

                    'button:cancel': {
                      target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',
                      actions: 'setCtxModalCloseOther'
                    }
                  },

                  after: {
                    timeOutCancel: {
                      target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',
                      actions: 'setCtxModalCloseOther'
                    }
                  },

                  exit: 'setCtxModalCloseOther'
                }
              },

              initial: 'INIT',

              onDone: [{
                target: 'BOOKING_FLOW.CHECK_PRINTER',
                cond: 'isTypeWalkIn'
              }, 'PAGE_INPUT_KEYPAD']
            },

            PAGE_INPUT_KEYPAD: {
              entry: ['setCtxPageInputKeypad'],

              on: {
                'button:lanjutkan': 'VALIDATION_CODE',

                'button:batalkan': {
                  target: 'MENU_PAGE',
                  actions: 'setCtxInputToZero'
                },

                'click:keypad': {
                  target: 'RESET_TIMEOUT',
                  actions: 'addCtxInputKey'
                },

                'click:anywhere': 'PAGE_INPUT_KEYPAD',
                'scan:ticket': {
                  target: 'VALIDATION_PENDAFTARAN',
                  actions: ['setCtxTypeActive', 'setCtxObjTicketResult', 'setCtxStrKeyCode'],
                  cond: 'isTypeBooking'
                }
              },

              after: {
                timeOutLinear: {
                  target: 'MENU_PAGE',
                  actions: 'setCtxInputToZero'
                }
              }
            },

            VALIDATION_CODE: {
              entry: ['setCtxPageLoading'],

              always: [{
                target: 'VALIDATION_PENDAFTARAN_QUEUE',
                cond: 'isCode'
              }, {
                target: 'GET_INFO_BY_PHONE',
                actions: 'setCtxKeyCheckNumber'
              }]
            },

            GET_INFO_BY_PHONE: {
              invoke: {
                src: 'getInfoBooking',
                onError: 'ERROR_PAGE_BOOKING'
              },

              on: {
                'on:info:booking': {
                  target: 'FLOW_CODE_OR_PHONE',
                  actions: 'setCtxListBookingWithPasient'
                }
              },

              after: {
                waitResponse: 'ERROR_PAGE_BOOKING'
              }
            },

            FLOW_CODE_OR_PHONE: {
              states: {
                INIT: {
                  always: [{
                    target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.LIST_TO_BOOKING',
                    cond: 'isPatientOnlyOne',
                    actions: 'setCtxSelectPasient'
                  }, 'PAGE_PATIENT_SHOW'],

                  entry: 'setCtxDisabledButton'
                },

                CREATE_QUEUE_PENDAFTARAN_MULTIPLE: {
                  entry: 'setCtxPageLoading',

                  states: {
                    INIT: {
                      invoke: {
                        src: 'postQueuePendaftaranMultiple',

                        onDone: 'SUCCESS_CREATE_PENDAFTARAN'
                      }
                    },

                    SUCCESS_CREATE_PENDAFTARAN: {
                      entry: 'setCtxSuccessMultipleTicket',

                      on: {
                        'on:create:pendaftaran': {
                          target: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.FLOW_CODE_OR_PHONE.SHOW_SUCCESS_MULTIPLE_PENDAFTARAN',
                          actions: ['setCtxListQueue', 'setCtxTicketMe', 'setCtxMutlipleBooking']
                        }
                      }
                    }
                  },

                  initial: 'INIT',

                  on: {
                    'after:pasien': {
                      target: '.INIT',
                      internal: false
                    }
                  }
                },

                PAGE_PATIENT_SHOW: {
                  entry: ['setCtxPageDoubleListPhone'],

                  on: {
                    'select:pasient': {
                      target: 'RESET_TIME',
                      actions: ['setCtxPasient', 'setCtxEnabledButton']
                    },

                    'button:batalkan': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',
                    'click:anywhere': 'PAGE_PATIENT_SHOW',

                    'button:lanjutkan': {
                      target: 'CHECK_TIPE_COUNTER',
                      cond: 'isEnable'
                    }
                  },

                  after: {
                    timeOutLinear: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                },

                RESET_TIME: {
                  always: 'PAGE_PATIENT_SHOW'
                },

                SHOW_SUCCESS_MULTIPLE_PENDAFTARAN: {
                  entry: ['setCtxSuccessTicket', 'setCtxPageSuccessPendaftaran'],

                  states: {
                    INIT: {
                      invoke: {
                        src: 'printTicketMultiple',
                        onError: 'SEND_ERROR'
                      }
                    },

                    SEND_ERROR: {
                      invoke: {
                        src: 'sendErrorPrint'
                      }
                    }
                  },

                  initial: 'INIT',

                  on: {
                    'print:after': {
                      target: '.INIT',
                      internal: false
                    },

                    'button:ok': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE',
                    'button:cancel': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  },

                  after: {
                    timeOutCancel: '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                },

                CHECK_PRINTER: {
                  always: [{
                    target: 'CREATE_QUEUE_PENDAFTARAN_MULTIPLE',
                    cond: 'isPrinterOK'
                  }, 'CONFIRM_PRINT']
                },

                CONFIRM_PRINT: {
                  entry: 'setCtxPageErrorPrinter',

                  on: {
                    'button:lanjutkan': 'CREATE_QUEUE_PENDAFTARAN_MULTIPLE',
                    'button:batalkan': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                },

                CHECK_TIPE_COUNTER: {
                  always: [{
                    target: 'errorPage',
                    cond: 'isDiffKioskMultiple'
                  }, 'CHECK_PRINTER']
                },

                errorPage: {
                  entry: ['setCtxErrorDiffKiosk', 'setCtxMutlipleBooking'],

                  on: {
                    'button:ok': '#KioskAntrian.INITIAL_CONFIGURATION.PAGE_HOME.MENU_PAGE'
                  }
                }
              },

              initial: 'INIT'
            },

            RESET_TIMEOUT: {
              always: 'PAGE_INPUT_KEYPAD'
            },

            LIST_TO_BOOKING: {
              always: 'BOOKING_FLOW',
              entry: 'setCtxToBooking'
            },

            ERROR_500: {
              entry: 'setCtxPageErrorServer',

              on: {
                'button:cancel': 'MENU_PAGE'
              },

              after: {
                timeOutCancel: 'MENU_PAGE'
              }
            },

            SHOW_MODAL_ATTENTION: {
              entry: 'setCtxModalAttentionSingle',
              exit: 'setCtxModalCloseAttentionSingle',

              on: {
                'button:lanjutkan': 'BOOKING_FLOW.CHECK_PRINTER',
                'button:batalkan': 'MENU_PAGE',

                'click:anywhere': 'SHOW_MODAL_ATTENTION'
              },

              after: {
                timeOutLinear: 'MENU_PAGE'
              }
            },

            ErrorPartial: {
              entry: 'setCtxPagePrintPartialError',

              on: {
                'button:cobalagi': 'BOOKING_FLOW.CREATE_QUEUE_TO_PENDAFTARAN',
                'button:batalkan': 'MENU_PAGE',
                'button:pendaftaran': 'BOOKING_FLOW.CREATE_QUEUE_TO_PENDAFTARAN'
              }
            }
          },

          entry: ['setCtxUnit', 'setCtxListPendaftaran']
        },

        VIDEO_ASSET: {
          states: {
            INIT: {
              invoke: {
                src: 'getAndSetVideo',
                onDone: 'DONE'
              }
            },

            DONE: {}
          },

          initial: 'INIT'
        },

        GET_LABEL: {
          states: {
            INIT: {
              invoke: {
                src: 'getLabelBadge',
                onDone: 'DONE'
              },

              exit: 'setCtxLabelBadge'
            },

            DONE: {}
          },

          initial: 'INIT'
        },

        LOADING_SCAN: {
          states: {
            INIT: {},

            PAGE_LOADING: {
              on: {
                'back:page': 'PAGE_BEFORE'
              }
            },

            PAGE_BEFORE: {}
          },

          initial: 'INIT',

          on: {
            'loading:page': '.PAGE_LOADING'
          }
        },

        REPRINT_TICKET: {
          states: {
            INIT: {},

            GET_LIST_ANTRIAN: {
              invoke: {
                src: 'getDataAntrian',
                onDone: 'CHANGE_GENERATED_ID',
                onError: 'ERROR_GET_DATA'
              }
            },

            CHANGE_GENERATED_ID: {
              invoke: {
                src: 'postNewGeneratedId',
                onDone: 'PRINT_TICKET',
                onError: 'ERROR_POST_GENERATED'
              },

              after: {
                waitResponse: 'GAGAL_REPRINT'
              }
            },

            PRINT_TICKET: {
              invoke: {
                src: 'printTicketQR'
              }
            },

            GAGAL_REPRINT: {
              entry: 'sendSlackSocketErrorReprint'
            },

            ERROR_GET_DATA: {},
            ERROR_POST_GENERATED: {}
          },

          initial: 'INIT',

          on: {
            'scan:reprint:ticket': {
              target: '.GET_LIST_ANTRIAN',
              internal: false
            }
          }
        },

        CHECK_PRINTER: {
          states: {
            INIT: {
              always: {
                target: 'GET_STATUS_PRINTER',
                cond: 'isStop'
              }
            },

            GET_STATUS_PRINTER: {
              invoke: {
                src: 'getStatusPrinter',
                onDone: 'SET_PRINTER_DATA',
                onError: 'SET_PRINTER_ERR_NETWORK'
              }
            },

            SET_PRINTER_DATA: {
              entry: 'setCtxErrorPrinter'
            },
            SET_PRINTER_ERR_NETWORK: {
              entry: 'setCtxErrorPrinter'
            }
          },

          initial: 'INIT',

          on: {
            'status:printer': {
              target: '.GET_STATUS_PRINTER',
              internal: false
            }
          }
        }
      },

      type: 'parallel'
    }
  },

  on: {
    'push:config': {
      target: '#KioskAntrian',
      actions: [
        'setCtxConfigNew',
        'setCtxUnit',
        'setCtxListPendaftaran',
        'setCtxHideModalGIF'
      ]
    }
  }
})
